import React, { useContext } from 'react';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import SkeletonLoaderContext from '@tcp/core/src/components/common/organisms/PromoModules/views/SkeletonLoaderContext.js';
import SkeletonLineView from '../../../../../common/molecules/LoaderSkelton/views/SkeletonLine.view';
import {
  CarouselSkeletonContainer,
  CarouselSkeletonPillContainer,
  CarouselPillLineContainer,
} from '../../styles/PaginatedPage.style';

const SKELETON_LINE_PILL_STYLE = { flex: 1, marginRight: 12, borderRadius: 25 };

export default function CarouselSkeleton({
  isOutfitCarouselPillDesignEnabled = false,
  isOutfitPillVariationEnabledOnAllPlps = false,
}) {
  const { extraConfig } = React.useContext(LabelsContext);
  const { isGlobalOutfitHeaderSectionVisibleWeb } = extraConfig || {};
  // Use context value
  const contextValue = useContext(SkeletonLoaderContext);
  // Combine prop and context value
  const isOutfitCarouselPillDesignEnabledValue =
    isOutfitCarouselPillDesignEnabled || isOutfitPillVariationEnabledOnAllPlps || contextValue;

  return !isOutfitCarouselPillDesignEnabledValue ? (
    <CarouselSkeletonContainer className="outfit-carousel-skeleton-container">
      {[1, 2, 3, 4, 5, 6].map((key) => (
        <SkeletonLineView className="skeleton-view" key={key} />
      ))}
    </CarouselSkeletonContainer>
  ) : (
    <CarouselSkeletonPillContainer>
      {!isGlobalOutfitHeaderSectionVisibleWeb ? (
        <SkeletonLineView height="30px" width="300px" />
      ) : (
        <></>
      )}
      <CarouselPillLineContainer>
        {[1, 2, 3, 4, 5, 6].map((key) => (
          <SkeletonLineView
            className="skeleton-pill-view"
            height="35px"
            width="100px"
            key={`${key}_pill`}
            style={SKELETON_LINE_PILL_STYLE}
          />
        ))}
      </CarouselPillLineContainer>
    </CarouselSkeletonPillContainer>
  );
}
